import { updateDoc, doc, getDoc, deleteDoc, collection, query, where, getDocs } from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { BudgetGroup, BudgetGroupInvite } from "../../types/budgethelper";

export const useUpdateBudgetGroup = () => {
	const leaveBudgetGroup = async (groupId: string, userId: string) => {
		const docRef = doc(firebaseDB, "budgetGroups", groupId);
		const docSnap = await getDoc(docRef);
		const userRef = doc(firebaseDB, "users", userId);
		const userSnap = await getDoc(userRef);

    if (docSnap.exists() && userSnap.exists()) {
      const data = docSnap.data();
			const userIds = (data.userIds as string[]).filter(uid => userId != uid);
			
			// If no members left, delete the budget group and all its transactions
			if (userIds.length === 0) {
				// Delete all transactions belonging to this budget group
				const transactionsRef = collection(firebaseDB, "transactions");
				const transactionsQuery = query(transactionsRef, where("budgetGroup", "==", groupId));
				const transactionsSnapshot = await getDocs(transactionsQuery);
				
				const deletePromises = transactionsSnapshot.docs.map(doc => deleteDoc(doc.ref));
				await Promise.all(deletePromises);
				
				// Delete the budget group
				await deleteDoc(docRef);
			} else {
				await updateDoc(docRef, {
					userIds
				});
			}

			const userData = userSnap.data();
			const budgetGroups = (userData.budgetGroups as string[]).filter(gid => groupId != gid);
			await updateDoc(userRef, {
				budgetGroups
			});
		};
	}

	const joinBudgetGroup = async (invite: BudgetGroupInvite) => {
		const docRef = doc(firebaseDB, "budgetGroups", invite.groupId);
		const docSnap = await getDoc(docRef);
		const userRef = doc(firebaseDB, "users", invite.invitedUserId);
		const userSnap = await getDoc(userRef);

    if (docSnap.exists() && userSnap.exists()) {
      const data = docSnap.data();
			const userIds = data.userIds as string[];
			userIds.push(invite.invitedUserId);
			await updateDoc(docRef, {
				userIds
			});

			const userData = userSnap.data();
			const budgetGroups = userData.budgetGroups as string[];
			budgetGroups.push(invite.groupId);
			await updateDoc(userRef, {
				budgetGroups
			});
		};
	}

	const updateBudgetGroupName = async (groupId: string, friendlyName: string) => {
		const docRef = doc(firebaseDB, "budgetGroups", groupId);
		await updateDoc(docRef, {
			friendlyName
		});
	}

	return { leaveBudgetGroup, joinBudgetGroup, updateBudgetGroupName };
};
